// store.ts
import { configureStore } from '@reduxjs/toolkit';
import drawerReducer from './slices/drawerSlice';
import authSlice from './slices/authSlice';
import accessReducer from './slices/accessSlice';

export const store = configureStore({
  reducer: {
    drawer: drawerReducer,
    auth: authSlice,
    access: accessReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['drawer/isOpen'],
        ignoredActionPaths: ['payload'],
        ignoredPaths: ['drawer.content', 'drawer.onClose', 'drawer.onSubmit', 'drawer.header'],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
